module.exports = __webpack_public_path__ + "img/02.18940fa6.png";